import { takeLatest, call, put } from "redux-saga/effects";

import * as types from "../actions/actionTypes";
import { ChequeAction } from "../actions";
import * as chequeApi from "../api/cheque";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherCheque() {
  yield takeLatest(types.GET_CHEQUE_LIST_REQUEST, getList);
  yield takeLatest(types.CHANGE_CHEQUE_STATUE_REQUEST, workerForChangeStatus);
}

function* getList() {
  try {
    const response = yield call(fetchList);
    let data = response.data.data;
    yield put(ChequeAction.getListSuccess(data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(ChequeAction.getListFailure({}));
  }
}

function* workerForChangeStatus(action) {
  try {
    const response = yield call(
      changeChequeStatus,
      action.chequeId,
      action.newStatus,
      action.source_type,
      action.source_id
    );
    yield put(ChequeAction.changeStatusSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(ChequeAction.changeStatusFailure(action.chequeId));
  }
}

async function changeChequeStatus(chequeId, newStatus, source_type, source_id) {
  return chequeApi.changeStatus(chequeId, newStatus, source_type, source_id);
}

function fetchList() {
  return chequeApi.getList();
}
